<template>
  <v-content v-if="loading">

    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>

    <!-- 确认框 -->
    <confirm ref="myConfirm"
             @clickFun="doDelete"></confirm>
    <!-- 提示框 -->
    <confirm ref="myAlert"></confirm>

    <v-row class="rows btn-group">
      <v-btn @click="addNews">添加</v-btn>
      <v-btn @click="toDelete">删除</v-btn>
    </v-row>

    <v-flex class="table-style">
      <v-data-table v-model="selected"
                    :headers="headers"
                    :items="tableData"
                    :single-select="singleSelect"
                    item-key="newsId"
                    show-select
                    class="elevation-1">
        <template v-slot:top>
          <v-switch v-model="singleSelect"
                    label="禁止多选"
                    class="pa-3"></v-switch>
        </template>
        <template v-slot:item.photo="{ item }">
          <img :src="item.photo"
               width="100"
               height="60" />
        </template>
        <template v-slot:item.newsTitle="{ item }">
          <span class="news-introduction"
                :title="item.newsTitle">{{ item.newsTitle}}</span>
        </template>
        <template v-slot:item.newsIntroduction="{ item }">
          <span class="news-introduction"
                :title="item.newsIntroduction">{{ item.newsIntroduction}}</span>
        </template>
        <template v-slot:item.releaseKbn="{ item }">
          <v-switch v-model="item.releaseKbn"
                    @change="updateNewsReleaseKbn(item)"></v-switch>
        </template>
        <template v-slot:item.option="{ item }">
          <v-icon small
                  class="mr-2"
                  @click="openNewContent(item,0)"
                  title="修改信息">fa fa-paint-brush</v-icon>
          <v-icon small
                  @click="PreviewNews(item)"
                  title="预览">fa fa-eye </v-icon>
        </template>
      </v-data-table>
    </v-flex>

    <!-- <v-row justify="center"> -->
    <!-- <v-dialog v-model="dialog"
              width="1000px"> -->
    <!-- <NewsEdit ref="mynews"
                v-bind:msg="test"
                class="pad" /> -->
    <v-dialog v-model="dialog"
              width="1080px">
      <!-- ↓ 增加、修改 ↓ -->
      <NewsEdit ref="myNewEdit"
                class="pad" />
    </v-dialog>
    <!-- </v-row> -->
  </v-content>
</template>

<script>

import Loading from '@/components/core/Loading'
import NewsEdit from './NewContentByAuthor'
import { EventBus } from './bus'

export default {
  components: { Loading, NewsEdit },
  data () {
    return {
      loading: false,
      singleSelect: false,
      test: '0',
      //选中的新闻
      selected: [],
      headers: [
        {
          text: '新闻标题',
          align: 'start',
          sortable: false,
          value: 'newsTitle',
        },
        { text: '缩略图', value: 'photo' },
        { text: '简介', value: 'newsIntroduction' },
        { text: '作者', value: 'newsAuthor' },
        { text: '创建时间', value: 'createTime' },
        { text: '更新时间', value: 'updateTime' },
        { text: '发布', value: 'releaseKbn' },
        { text: "操作", value: "option", sortable: false }
      ],
      tableData: [],
      isLoading: false,
      // dialog: true,
      dialog: false,
    }
  },
  created () {
    this.init();
    // this.$refs.mynews.init();
  },
  mounted () {
    this.$emit("updateNavigationValue", 3);
  },
  methods: {
    //初期化
    init () {
      this.isLoading = true;
      this.$store
        .dispatch("GetAllNewsList")
        .then(response => {
          this.tableData = response.data.data;
          this.isLoading = false;
        })
        .catch(() => { this.isLoading = false; });
      this.loading = true;
    },

    //添加新闻
    addNews () {
      // let routeData = this.$router.resolve(
      //   { name: 'NewContentByAuthor', query: { kbn: 1 } }
      // );
      // window.open(routeData.href, '_blank');
      this.dialog = true;
      this.$nextTick(() => {
        EventBus.$emit("newsType", 1, 0)
      });
      // this.$refs.mynews.init();
    },
    //修改新闻
    // openNewContent (item, val) {
    //   let routeData = this.$router.resolve(
    //     { name: 'NewContentByAuthor', query: { newsId: item.newsId, kbn: val } }
    //   );
    //   window.open(routeData.href, '_blank');
    // },
    // ↓ 修改新闻
    openNewContent (item) {
      this.dialog = true;
      this.$nextTick(() => {
        EventBus.$emit("newsType", 0, item.newsId)
      });
    },

    //预览新闻
    PreviewNews (item) {
      let routeData = this.$router.resolve(
        { name: 'PreviewNews', query: { newsId: item.newsId } }
      );
      window.open(routeData.href, '_blank');
    },


    //删除
    toDelete () {
      if (this.selected.length > 0) {
        this.$refs.myConfirm.show("确认删除所选新闻吗?", {})
      } else {
        this.$refs.myAlert.show("请选择新闻", {
          type: 'alert'
        })
      }
      // EventBus.$emit("newsType", 1);
      // this.dialog = true;
      // this.$refs.mynews.init();
    },

    //确认删除
    doDelete (type) {
      if (type == "clickConfirm") {
        this.isLoading = true;
        var newsIds = [];
        this.selected.forEach(item => {
          newsIds.push(parseInt(item.newsId));
        })
        this.$store.dispatch("DeleteNews", newsIds).then(response => {
          let result = response.data.data;
          let str = "";
          str = result == 200 ? "删除成功!" : "删除失败!";
          this.isLoading = false;
          this.$refs.myAlert.show(str, {
            type: 'alert'
          })
          this.init();
        })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    //修改新闻发布状态
    updateNewsReleaseKbn (item) {
      this.isLoading = true;
      item.updateTime = sessionStorage.token;
      item.releaseKbn = item.releaseKbn ? 1 : 0;
      this.$store.dispatch("UpdateNewsReleaseKbn", item).then(response => {
        let result = response.data.data;
        this.isLoading = false;
        if (result == 500 || result == 401) {
          item.releaseKbn = item.releaseKbn == 1 ? false : true
          let str = result == 500 ? "状态修改失败!" : "身份过期，请重新登录!";
          this.$refs.myAlert.show(str, {
            type: 'alert'
          })
        }
        this.init();
      })
        .catch(() => {
          this.isLoading = false;
        });
    }

  }
}
</script>

<style scoped>
.rows {
  margin: 0;
  justify-items: center;
  align-items: center;
}
.pad {
  padding: 0px !important;
  /* overflow: hidden !important; */
}
.btn-group {
  flex: none !important;
  width: 300px;
}
.btn-group >>> .v-btn {
  margin: 5px;
  background: cadetblue !important;
}
.table-style {
  width: 98%;
  max-height: 870px;
  overflow: auto;
}
.news-introduction {
  max-width: 200px !important;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.textarea-news >>> .v-text-field__slot {
  height: 100px;
  border: 2px inset rgb(240, 234, 234);
}
.image {
  width: 290px;
  height: 125px;
}
</style>